import React from 'react';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider
} from '@material-ui/pickers';

export const DatePicker = ({ ...props }) =>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
            {...props}
        />
    </MuiPickersUtilsProvider>;

DatePicker.propTypes = {
    autoOk: PropTypes.bool,
    disabled: PropTypes.bool,
    emptyLabel: PropTypes.string,
    format: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    orientation: PropTypes.oneOf(['portrait', 'landscape']),
    value: PropTypes.instanceOf(Date),
    variant: PropTypes.oneOf(['dialog', 'inline', 'static']),
    placeholder: PropTypes.string
};

DatePicker.defaultProps = {
    autoOk: false,
    disabled: false,
    emptyLabel: '',
    label:'',
    format: 'yyyy/MM/dd',
    orientation: 'portrait',
    value: null,
    variant: 'inline',
    placeholder: 'Pick a date'
};

export default DatePicker;
